import { DRAWER_FIELDS } from "./taskConstants";

export const roundHours = (value) => Math.round(Number(value || 0) * 100) / 100;

export const formatHours = (value) => `${roundHours(value).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} h`;

export const formatDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString("fr-FR");
};

export const parseDurationToHours = (rawValue) => {
  const raw = String(rawValue || "").trim().toLowerCase();
  if (!raw) return NaN;

  const compact = raw.replace(/\s+/g, "");
  const colon = compact.match(/^(\d+):(\d{1,2})$/);
  if (colon) return Number(colon[2]) < 60 ? roundHours(Number(colon[1]) + Number(colon[2]) / 60) : NaN;
  const duration = compact.match(/^(?:(\d+(?:[.,]\d+)?)h(?:(\d+(?:[.,]\d+)?)(?:m(?:in)?)?)?|(\d+(?:[.,]\d+)?)m(?:in)?)$/);
  if (duration) return roundHours(Number((duration[1] || "0").replace(",", ".")) + Number((duration[2] || duration[3] || "0").replace(",", ".")) / 60);
  if (!/^\d+(?:[.,]\d+)?$/.test(compact)) return NaN;
  return roundHours(Number(compact.replace(",", ".")));
};

export const getCommentPreview = (commentaire) => {
  const text = String(commentaire || "").trim();
  if (!text) return "Ajouter";
  return text.length > 42 ? `${text.slice(0, 42)}...` : text;
};

export const buildDrawerPatch = (task, draft) => {
  const patch = {};

  DRAWER_FIELDS.forEach((field) => {
    let nextValue = draft[field];
    let currentValue = task[field];

    if (field === "titre") {
      nextValue = String(nextValue || "").trim();
      currentValue = String(currentValue || "").trim();
    } else if (field === "commentaire" || field === "notes_internes") {
      nextValue = String(nextValue || "");
      currentValue = String(currentValue || "");
    } else if (field === "heures_estimees" || field === "taux_horaire") {
      nextValue = nextValue === "" ? null : Number(nextValue);
      currentValue = currentValue == null ? null : Number(currentValue);
    } else if (field === "facturable") {
      nextValue = Boolean(nextValue);
      currentValue = Boolean(currentValue);
    } else if (field === "date_tache") {
      nextValue = nextValue || "";
      currentValue = currentValue || "";
    }

    if (nextValue !== currentValue) {
      patch[field] = nextValue;
    }
  });

  return patch;
};
